module.exports = {
  platform() {},
  release() {},
};
